import { render, staticRenderFns } from "./getCard.vue?vue&type=template&id=202e7259&scoped=true&"
import script from "./getCard.vue?vue&type=script&lang=js&"
export * from "./getCard.vue?vue&type=script&lang=js&"
import style0 from "./getCard.vue?vue&type=style&index=0&id=202e7259&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202e7259",
  null
  
)

export default component.exports